var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',{staticClass:"requirement-record",on:{"click":_vm.redirectToShowPage}},[_c('td',{staticClass:"pa-1 normal-wrap text-center sticky-01",domProps:{"textContent":_vm._s(_vm.deliveryInfo.shipping_date ? _vm.toDateFormat(_vm.deliveryInfo.shipping_date) : '')},on:{"click":function($event){_vm.openEditDialog(
				'shipping_date',
				_vm.deliveryInfo.shipping_date ? _vm.toDateFormat(_vm.deliveryInfo.shipping_date) : null,
				null,
				'出荷日'
			)}}}),_vm._v(" "),_c('td',{staticClass:"pa-1 normal-wrap text-center sticky-02",domProps:{"textContent":_vm._s(_vm.orderedProduct.keyword)}}),_vm._v(" "),_c('td',{staticClass:"pa-1 normal-wrap text-center sticky-03"},[_c('a',{on:{"click":function($event){_vm.orderedProductOpenFlag = true}}},[_vm._v("\n\t\t\t"+_vm._s(_vm.orderedProduct.product_number)+"\n\t\t")])]),_vm._v(" "),_c('td',{staticClass:"pa-1 normal-wrap text-center sticky-04"},[_c('a',{on:{"click":function($event){_vm.orderIndividualInfoOpenFlag = true}}},[_vm._v("\n\t\t\t"+_vm._s(_vm.common.zeroPadding(_vm.orderIndividualInfo.sub_number, 3))+"\n\t\t")])]),_vm._v(" "),_c('td',{staticClass:"pa-1 normal-wrap text-center sticky-05",domProps:{"textContent":_vm._s(_vm.requirement.user.last_name)}}),_vm._v(" "),_c('td',{staticClass:"pa-1 normal-wrap text-center sticky-06",domProps:{"textContent":_vm._s(_vm.requirement.matter.order_number)}}),_vm._v(" "),_c('td',{staticClass:"pa-1 normal-wrap text-center",domProps:{"textContent":_vm._s(
			_vm.orderIndividualInfo.shipping_permit_date
				? _vm.toDateFormat(_vm.orderIndividualInfo.shipping_permit_date)
				: ''
		)}}),_vm._v(" "),_c('td',{staticClass:"pa-1 normal-wrap text-center"},[_vm._v("\n\t\t"+_vm._s(_vm.orderIndividualInfo.permit_user ? _vm.orderIndividualInfo.permit_user.last_name : "")+"\n\t")]),_vm._v(" "),_c('td',{staticClass:"pa-1 normal-wrap text-center",domProps:{"textContent":_vm._s(_vm.orderedProduct.product.name)}}),_vm._v(" "),_c('td',{staticClass:"pa-1 normal-wrap text-center",domProps:{"textContent":_vm._s(_vm.orderedProduct.sub_name)}}),_vm._v(" "),_c('td',{staticClass:"pa-1 normal-wrap text-center",domProps:{"textContent":_vm._s(_vm.orderIndividualInfo.quantity)}}),_vm._v(" "),_c('td',{staticClass:"pa-1 normal-wrap text-center",domProps:{"textContent":_vm._s(_vm.matter.regular_customer.name)}}),_vm._v(" "),_c('td',{staticClass:"pa-1 normal-wrap text-center",domProps:{"textContent":_vm._s(_vm.matter.customer_company.name)}}),_vm._v(" "),_c('td',{staticClass:"pa-1 normal-wrap text-center",domProps:{"textContent":_vm._s(_vm.deliveryInfo.prefecture)},on:{"click":function($event){return _vm.openEditDialog(
				'prefecture',
				_vm.deliveryInfo.prefecture ? _vm.deliveryInfo.prefecture : null,
				null,
				'都道府県'
			)}}}),_vm._v(" "),_c('td',{staticClass:"pa-1 normal-wrap text-center",domProps:{"textContent":_vm._s(_vm.deliveryInfo.city)},on:{"click":function($event){return _vm.openEditDialog('city', _vm.deliveryInfo.city ? _vm.deliveryInfo.city : null, null, '市郡町村')}}}),_vm._v(" "),_c('td',{staticClass:"pa-1 normal-wrap text-center",domProps:{"textContent":_vm._s(_vm.toDateFormat(_vm.deliveryInfo.deadline))},on:{"click":function($event){_vm.openEditDialog(
				'deadline',
				_vm.deliveryInfo.deadline ? _vm.toDateFormat(_vm.deliveryInfo.deadline) : null,
				null,
				'納期'
			)}}}),_vm._v(" "),_c('td',{staticClass:"pa-1 normal-wrap text-center",domProps:{"textContent":_vm._s(_vm.selectValueFromValues('特記事項'))},on:{"click":function($event){_vm.openEditDialog(
				'remarks',
				_vm.selectValueFromValues('特記事項'),
				_vm.selectValueIdFromValues('特記事項'),
				'特記事項'
			)}}}),_vm._v(" "),_c('td',{staticClass:"pa-1 normal-wrap text-center",domProps:{"textContent":_vm._s(_vm.selectValueFromValues('運送方法'))},on:{"click":function($event){_vm.openEditDialog(
				't_method',
				_vm.selectValueFromValues('運送方法'),
				_vm.selectValueIdFromValues('運送方法'),
				'運送方法'
			)}}}),_vm._v(" "),_c('td',{staticClass:"pa-1 normal-wrap text-center",domProps:{"textContent":_vm._s(_vm.selectValueFromValues('車種'))},on:{"click":function($event){_vm.openEditDialog(
				'car_model',
				_vm.selectValueFromValues('車種'),
				_vm.selectValueIdFromValues('車種'),
				'車種'
			)}}}),_vm._v(" "),_c('td',{staticClass:"pa-1 normal-wrap text-center",domProps:{"textContent":_vm._s(_vm.selectValueFromValues('台数'))},on:{"click":function($event){_vm.openEditDialog(
				'number_of_vehicles',
				_vm.selectValueFromValues('台数'),
				_vm.selectValueIdFromValues('台数'),
				'台数'
			)}}}),_vm._v(" "),_c('td',{staticClass:"pa-1 normal-wrap text-center",domProps:{"textContent":_vm._s(_vm.selectValueFromValues('荷姿'))},on:{"click":function($event){_vm.openEditDialog(
				'packing_style',
				_vm.selectValueFromValues('荷姿'),
				_vm.selectValueIdFromValues('荷姿'),
				'荷姿'
			)}}}),_vm._v(" "),_c('td',{staticClass:"pa-1 normal-wrap text-center",domProps:{"textContent":_vm._s(_vm.selectValueFromValues('個数'))},on:{"click":function($event){_vm.openEditDialog(
				'number_of_paking',
				_vm.selectValueFromValues('個数'),
				_vm.selectValueIdFromValues('個数'),
				'個数'
			)}}}),_vm._v(" "),_c('td',{staticClass:"pa-1 normal-wrap text-center",domProps:{"textContent":_vm._s(
			_vm.selectValueFromValues('重量(kg)') ? _vm.selectValueFromValues('重量(kg)').toLocaleString() : ''
		)},on:{"click":function($event){_vm.openEditDialog(
				'kg',
				_vm.selectValueFromValues('重量(kg)'),
				_vm.selectValueIdFromValues('重量(kg)'),
				'重量(kg)'
			)}}}),_vm._v(" "),_c('td',{staticClass:"pa-1 pre-wrap text-center",domProps:{"textContent":_vm._s(_vm.selectValueFromValues('備考'))},on:{"click":function($event){_vm.openEditDialog(
				'biko',
				_vm.selectValueFromValues('備考'),
				_vm.selectValueIdFromValues('備考'),
				'備考'
			)}}}),_vm._v(" "),_c('td',{staticClass:"pa-1 normal-wrap text-center",domProps:{"textContent":_vm._s(_vm.selectValueFromValues('梱包指定'))},on:{"click":function($event){_vm.openEditDialog(
				'packing_spec',
				_vm.selectValueFromValues('梱包指定'),
				_vm.selectValueIdFromValues('梱包指定'),
				'梱包指定'
			)}}}),_vm._v(" "),_c('td',{staticClass:"pa-1 normal-wrap text-center",domProps:{"textContent":_vm._s(_vm.selectValueFromValues('送品案内'))},on:{"click":function($event){_vm.openEditDialog(
				'shipping_guide',
				_vm.selectValueFromValues('送品案内'),
				_vm.selectValueIdFromValues('送品案内'),
				'送品案内'
			)}}}),_vm._v(" "),_c('td',{staticClass:"pa-1 normal-wrap text-center",domProps:{"textContent":_vm._s(_vm.selectValueFromValues('指定伝票'))},on:{"click":function($event){_vm.openEditDialog(
				'designated_form',
				_vm.selectValueFromValues('指定伝票'),
				_vm.selectValueIdFromValues('指定伝票'),
				'指定伝票'
			)}}}),_vm._v(" "),_c('td',{staticClass:"pa-1 normal-wrap text-center",domProps:{"textContent":_vm._s(_vm.selectValueFromValues('成績書'))},on:{"click":function($event){_vm.openEditDialog(
				'report_of_results',
				_vm.selectValueFromValues('成績書'),
				_vm.selectValueIdFromValues('成績書'),
				'成績書'
			)}}}),_vm._v(" "),_c('td',{staticClass:"pa-1 normal-wrap text-center",domProps:{"textContent":_vm._s(_vm.selectValueFromValues('現品表'))},on:{"click":function($event){_vm.openEditDialog(
				'specimen_list',
				_vm.selectValueFromValues('現品表'),
				_vm.selectValueIdFromValues('現品表'),
				'現品表'
			)}}}),_vm._v(" "),_c('td',{staticClass:"pa-1 normal-wrap text-center",domProps:{"textContent":_vm._s(_vm.selectValueFromValues('返信封筒'))},on:{"click":function($event){_vm.openEditDialog(
				'return_envelope',
				_vm.selectValueFromValues('返信封筒'),
				_vm.selectValueIdFromValues('返信封筒'),
				'返信封筒'
			)}}}),_vm._v(" "),_c('td',{staticClass:"pa-1 normal-wrap text-center",domProps:{"textContent":_vm._s(_vm.selectValueFromValues('図面'))},on:{"click":function($event){_vm.openEditDialog(
				'drawing',
				_vm.selectValueFromValues('図面'),
				_vm.selectValueIdFromValues('図面'),
				'図面'
			)}}}),_vm._v(" "),_c('td',{staticClass:"pa-1 normal-wrap text-center",domProps:{"textContent":_vm._s(_vm.selectValueFromValues('地図'))},on:{"click":function($event){_vm.openEditDialog('map', _vm.selectValueFromValues('地図'), _vm.selectValueIdFromValues('地図')),
				'地図'}}}),_vm._v(" "),_c('td',{staticClass:"pa-1 normal-wrap text-center",domProps:{"textContent":_vm._s(_vm.selectValueFromValues('出荷許可'))},on:{"click":function($event){_vm.openEditDialog(
				'shipping_permittion',
				_vm.selectValueFromValues('出荷許可'),
				_vm.selectValueIdFromValues('出荷許可'),
				'出荷許可'
			)}}}),_vm._v(" "),_c('td',{staticClass:"pa-1 normal-wrap text-center",domProps:{"textContent":_vm._s(
			_vm.selectValueFromValues('運送費') ? _vm.selectValueFromValues('運送費').toLocaleString() : ''
		)},on:{"click":function($event){_vm.openEditDialog(
				'freight_costs',
				_vm.selectValueFromValues('運送費'),
				_vm.selectValueIdFromValues('運送費'),
				'運送費'
			)}}}),_vm._v(" "),_c('td',{staticClass:"pa-1 normal-wrap text-center",domProps:{"textContent":_vm._s(_vm.selectValueFromValues('運賃') ? _vm.selectValueFromValues('運賃').toLocaleString() : '')},on:{"click":function($event){_vm.openEditDialog(
				'fare',
				_vm.selectValueFromValues('運賃'),
				_vm.selectValueIdFromValues('運賃'),
				'運賃'
			)}}}),_vm._v(" "),_c('td',{staticClass:"pa-1 normal-wrap text-center",domProps:{"textContent":_vm._s(
			_vm.selectValueFromValues('中継料') ? _vm.selectValueFromValues('中継料').toLocaleString() : ''
		)},on:{"click":function($event){_vm.openEditDialog(
				'relay_fee',
				_vm.selectValueFromValues('中継料'),
				_vm.selectValueIdFromValues('中継料'),
				'中継料'
			)}}}),_vm._v(" "),_c('td',{staticClass:"pa-1 normal-wrap text-center",domProps:{"textContent":_vm._s(
			_vm.selectValueFromValues('冬季割増料')
				? _vm.selectValueFromValues('冬季割増料').toLocaleString()
				: ''
		)},on:{"click":function($event){_vm.openEditDialog(
				'winter_surcharge',
				_vm.selectValueFromValues('冬季割増料'),
				_vm.selectValueIdFromValues('冬季割増料'),
				'冬季割増料'
			)}}}),_vm._v(" "),_c('td',{staticClass:"pa-1 normal-wrap text-center",domProps:{"textContent":_vm._s(
			_vm.selectValueFromValues('保険料') ? _vm.selectValueFromValues('保険料').toLocaleString() : ''
		)},on:{"click":function($event){_vm.openEditDialog(
				'insurance_premium',
				_vm.selectValueFromValues('保険料'),
				_vm.selectValueIdFromValues('保険料'),
				'保険料'
			)}}}),_vm._v(" "),_c('td',{staticClass:"pa-1 normal-wrap text-center",domProps:{"textContent":_vm._s(
			_vm.selectValueFromValues('チャーター料')
				? _vm.selectValueFromValues('チャーター料').toLocaleString()
				: ''
		)},on:{"click":function($event){_vm.openEditDialog(
				'charter_fee',
				_vm.selectValueFromValues('チャーター料'),
				_vm.selectValueIdFromValues('チャーター料'),
				'チャーター料'
			)}}}),_vm._v(" "),_c('td',{staticClass:"pa-1 normal-wrap text-center",domProps:{"textContent":_vm._s(_vm.selectValueFromValues('受領書'))},on:{"click":function($event){_vm.openEditDialog(
				'receipt',
				_vm.selectValueFromValues('受領書'),
				_vm.selectValueIdFromValues('受領書'),
				'受領書'
			)}}}),_vm._v(" "),_c('td',{staticClass:"pa-1 normal-wrap text-center",domProps:{"textContent":_vm._s(_vm.selectValueFromValues('発注＆受入したか'))},on:{"click":function($event){_vm.openEditDialog(
				'ordered_accepted',
				_vm.selectValueFromValues('発注＆受入したか'),
				_vm.selectValueIdFromValues('発注＆受入したか'),
				'発注＆受入したか'
			)}}}),_vm._v(" "),_c('td',{staticClass:"pa-1 normal-wrap text-center",domProps:{"textContent":_vm._s(_vm.getQuoteRequestNumber())}}),_vm._v(" "),_c('td',{staticClass:"pa-1 normal-wrap text-center",domProps:{"textContent":_vm._s(_vm.getQuoteRequestAnswerDate())}}),_vm._v(" "),_c('td',{staticClass:"pa-1 normal-wrap text-center",domProps:{"textContent":_vm._s(_vm.selectQuotePrice('オーナミ') ? _vm.selectQuotePrice('オーナミ').toLocaleString() : '')}}),_vm._v(" "),_c('td',{staticClass:"pa-1 normal-wrap text-center",domProps:{"textContent":_vm._s(
			_vm.selectQuotePrice('日本ロジコム') ? _vm.selectQuotePrice('日本ロジコム').toLocaleString() : ''
		)}}),_vm._v(" "),_c('td',{staticClass:"pa-1 normal-wrap text-center",domProps:{"textContent":_vm._s(_vm.selectQuotePrice('城南運輸') ? _vm.selectQuotePrice('城南運輸').toLocaleString() : '')}}),_vm._v(" "),_c('LogisticsEditDialog',{ref:"edit",on:{"reloadIndex":_vm.reloadIndex}}),_vm._v(" "),(_vm.orderedProductOpenFlag)?_c('OrderedProductSingleDialog',{attrs:{"ordered_product":_vm.orderedProduct},on:{"close":function($event){_vm.orderedProductOpenFlag = false}}}):_vm._e(),_vm._v(" "),(_vm.orderIndividualInfoOpenFlag)?_c('OrderIndividualInfoSingleDialog',{attrs:{"ordered_product":_vm.orderedProduct,"order_individual_info":_vm.orderIndividualInfo},on:{"close":function($event){_vm.orderIndividualInfoOpenFlag = false}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }